import styled from '@emotion/styled'
import { css } from '@emotion/react'

import media from '../../../../styles/media'

const S = {}

S.Content = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  color: white;
  padding-inline: var(--arrow-offset);

  .container {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    row-gap: 1.125rem;
    transform: translateY(-0.5625rem);

    ${media.sm`
      row-gap: 2rem;
      transform: translateY(-1.375rem);
    `};

    ${media.md`
      flex-direction: row;
      column-gap: 1.875rem;
      transform: translateY(0);
    `};
  }

  .image {
    margin-left: auto;
    margin-right: auto;

    ${media.md`
      order: 1;
      flex-shrink: 0;

      [dir='rtl'] & {
        order: 0;
      }
    `};

    ${({ ratio }) =>
      ratio === '16x9' &&
      css`
        width: 100%;
        max-width: 20.9375rem;
        max-height: 11.8125rem;

        ${media.sm`
          max-width: 41.75rem;
          max-height: 24.1875rem;
        `};

        ${media.md`
          width: 57.2%;
        `};
      `};

    ${({ ratio }) =>
      ratio === '2x3' &&
      css`
        width: 8.75rem;
        aspect-ratio: 2 / 3;

        ${media.sm`
          width: 18.4375rem;
        `};

        ${media.md`
          width: 20.6875rem;
        `};
      `};
  }

  .text {
    text-align: center;
    [dir='rtl'] & {
      direction: rtl;
    }

    ${media.md`
    text-align: left;
    max-width: 26.25rem;

      [dir='rtl'] & {
        text-align: right;
      }
    `};
  }

  .title {
    margin-bottom: 0.75rem;
    ${media.sm`
    margin-bottom: 0.5rem;
    `};
    ${media.md`
    margin-bottom: 0.75rem;
    `};
  }

  .copy {
    min-height: 7rem;

    ${media.sm`
      min-height: auto;
    `};

    p {
      font-size: 1rem;
      line-height: 1.5rem;

      + p {
        margin-top: 0.75rem;
      }
    }
  }

  .cta {
    margin-top: 1.5rem;
    ${media.md`
      margin-top: 2.5rem;
    `};
  }
`
export default S
